import Get_clienti from "./components/componets_gest/get_clienti"
export default function Ges_homepage (){
    return (
        <>
            <Get_clienti></Get_clienti>
        </>
    )
}